import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import Image from 'next/image';

type ListType = {
    title: string;
};

type RealizationProps = {
    list: ListType[];
    listStages: { description: string }[];
};
const Realization = ({ list, listStages }: RealizationProps) => {
    return (
        <div className="rgs-realization">
            <FullWrapper className="rgs-realizationCase" isMargin={false}>
                <div className="rgs-realizationWrapper">
                    <div className="rgs-realizationBottom">Этапы реализации</div>
                    <div className="rgs-realizationParagraf">
                        Команда аналитиков собирала и&nbsp;оформила требования не&nbsp;только
                        по&nbsp;нашей системе, но&nbsp;и&nbsp;частично по&nbsp;смежным сервисам,
                        прорабатывали детали для предотвращения потенциальных конфликтов при
                        интеграциях.
                    </div>
                    <div className="rgs-realizationList">
                        {listStages.map(({ description }, index) => (
                            <div key={index} className="rgs-realizationItem">
                                <div className="rgs-realizationCircle"></div>
                                <div
                                    dangerouslySetInnerHTML={{ __html: description }}
                                    className="rgs-realizationText"
                                />
                            </div>
                        ))}
                    </div>

                    <div className="rgs-realizationParagraf">
                        В&nbsp;процессе работы над проектом вместе с&nbsp;командой
                        &laquo;Росгосстрах&raquo; определяли стратегическое видение развития личного
                        кабинета продавца и&nbsp;приоритезировали задачи по&nbsp;доработке продуктов
                        КАСКО и&nbsp;ОСАГО.
                    </div>
                </div>
            </FullWrapper>
            <div className="rgs-realizationTechnologies">
                <FullWrapper isMargin={false}>
                    <div className="rgs-realizationTechnologiesMainTitle">Тестирование</div>
                    <div className="rgs-realizationTechnologiesContent">
                        <div className="rgs-realizationTechnologiesLeft">
                            <div className="rgs-realizationTechnologiesParagraf">
                                Создали многоуровневую модель тестов с&nbsp;высоким процентом
                                покрытия и&nbsp;обеспечивающую контроль качества на&nbsp;всех этапах
                                разработки
                            </div>
                            <div className="rgs-realizationTechnologiesTitle">
                                Технологии для нагрузочного и&nbsp;автоматизированного тестирования
                            </div>
                            <div className="rgs-realizationTechnologiesList">
                                {list &&
                                    list.map(({ title }) => (
                                        <div
                                            className="rgs-realizationTechnologiesItem"
                                            key={title}
                                        >
                                            <div
                                                className="rgs-realizationTechnologiesText"
                                                dangerouslySetInnerHTML={{ __html: title }}
                                            ></div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <div className="rgs-realizationTechnologiesRight">
                            <Image
                                src="/images/pic/rgs/triangle.png"
                                alt="marker"
                                width={832}
                                height={607}
                                className="rgs-realizationTechnologiesImg"
                            />
                        </div>
                    </div>
                </FullWrapper>
            </div>
        </div>
    );
};

export default Realization;
